/**
 * Fila de cuadros con titulo encima (ADM-05): cuatro piezas de lado a lado,
 * cada una con el nombre de lo que promociona y un "Ver productos".
 *
 * Al reves que el carrusel y las promociones, aca la imagen es solo la foto y
 * el texto lo escribe la portada: asi el panel cambia el titulo o la bajada
 * sin pedirle una pieza nueva a nadie. El velo oscuro que hace legible el
 * texto viene en la imagen misma.
 *
 * Es una lista de enlaces y cada titulo es un `<h3>` bajo el `<h2>` oculto de
 * la seccion: la jerarquia de encabezados de la portada no salta.
 */
import type { Banner } from '@bandu/compartido';

import { Icono } from '../comunes/Icono';
import { LaminaBanner } from './LaminaBanner';

export interface FilaCuadrosProps {
  banners: Banner[];
}

export function FilaCuadros({ banners }: FilaCuadrosProps) {
  if (banners.length === 0) return null;

  return (
    <section className="cuadros-seccion" aria-labelledby="cuadros-titulo">
      <h2 id="cuadros-titulo" className="solo-lectores">
        Destacados de la temporada
      </h2>
      <ul className="cuadros">
        {banners.map((banner) => (
          <li key={banner.id} className="cuadro">
            <LaminaBanner banner={banner}>
              <div className="cuadro-texto">
                {banner.titulo !== null ? <h3>{banner.titulo}</h3> : null}
                {banner.bajada !== null ? <p>{banner.bajada}</p> : null}
                {banner.enlace !== null ? (
                  <span className="cuadro-boton">
                    Ver productos
                    <Icono nombre="flecha" />
                  </span>
                ) : null}
              </div>
            </LaminaBanner>
          </li>
        ))}
      </ul>
    </section>
  );
}
